import { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { SbRespNullSearchResultsTilesLoader } from '../../finding/SbRespNullSearchResults/SbRespNullSearchResultsTilesLoader';
import { CategoryRooms } from 'dibs-buyer-layout/exports/CategoryLinks';
import { SbMobileNullSearchResults } from '../../finding/SbMobileNullSearchResults/SbMobileNullSearchResults';
import {
    trackL1ModuleClick,
    trackCreatorModuleClick,
    trackRoomModuleClick,
} from '../../utils/tracking/searchBrowse/nullResultsTracking';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import styles from '../../finding/SbSharedTitle/SbSharedTitle.scss';

const onRoomModuleClick = (e, { room }) => trackRoomModuleClick(room.type);

export const BuySharedNullSearchResultsComponent = ({ relay, viewer, buyPage }) => {
    const { isShopByRoomEnabled } = viewer;
    const { meta } = buyPage;
    const { environment } = relay;

    const { isMobile } = useContext(ServerVarsContext);

    return (
        <Fragment>
            <div className={styles.container}>
                <h1 className={styles.header} data-tn="header-title">
                    {meta.header}
                </h1>
            </div>

            {isMobile ? (
                <SbMobileNullSearchResults
                    onL1ModuleClick={trackL1ModuleClick}
                    onCreatorModuleClick={trackCreatorModuleClick}
                    onRoomModuleClick={trackRoomModuleClick}
                />
            ) : (
                <Fragment>
                    <SbRespNullSearchResultsTilesLoader environment={environment} />
                    {isShopByRoomEnabled && <CategoryRooms onClick={onRoomModuleClick} />}
                </Fragment>
            )}
        </Fragment>
    );
};

BuySharedNullSearchResultsComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    buyPage: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
};

export const BuySharedNullSearchResults = createFragmentContainer(
    BuySharedNullSearchResultsComponent,
    {
        viewer: graphql`
            fragment BuySharedNullSearchResults_viewer on Viewer {
                isShopByRoomEnabled: isEnabledByLocale(featureName: "SHOP_BY_ROOM")
            }
        `,
        buyPage: graphql`
            fragment BuySharedNullSearchResults_buyPage on ItemSearchQueryConnection {
                meta {
                    header
                }
            }
        `,
    }
);
